import { getProto } from '../../im/pb-imports';

export type CallMessageSummary = {
  callId: string;
  media: 'audio' | 'video';
  outcome: string;
  durationMs?: number;
  scope: 'direct' | 'group';
  groupName?: string;
  joinedParticipantCount?: number;
};

const labels: Record<string, string> = { completed: '通话结束', declined: '已拒绝', cancelled: '已取消', missed: '未接听', busy: '对方忙线', failed: '未接通', disconnected: '已断开' };

function uuidText(bytes: Uint8Array): string | null {
  if (bytes.length !== 16) return null;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function parseCallMessage(bytes?: Uint8Array): CallMessageSummary | null {
  if (!bytes?.length) return null;
  try {
    const proto = getProto(); const content = proto.IM.Call.CallMessageContent.deserializeBinary(bytes);
    if (content.getSchemaVersion() !== 1) return null;
    const callId = uuidText(content.getCallId_asU8());
    if (!callId) return null;
    const names: Record<number, string> = { 1: 'completed', 2: 'declined', 3: 'cancelled', 4: 'missed', 5: 'busy', 6: 'failed', 7: 'disconnected' };
    const outcome = names[content.getTerminalOutcome()]; if (!outcome) return null;
    const durationMs = content.getDurationMs?.();
    const scope = content.getScope() === proto.IM.Call.CallScope.CALL_SCOPE_GROUP ? 'group' : 'direct';
    const groupName = content.getGroupNameSnapshot?.();
    const joinedParticipantCount = content.getJoinedParticipantCount?.();
    return { callId, scope, media: content.getMediaKind() === proto.IM.Call.CallMediaKind.CALL_MEDIA_KIND_VIDEO ? 'video' : 'audio', outcome, ...(durationMs ? { durationMs } : {}), ...(scope === 'group' && groupName ? { groupName } : {}), ...(scope === 'group' && joinedParticipantCount ? { joinedParticipantCount } : {}) };
  } catch { return null; }
}
export function callMessagePreview(bytes?: Uint8Array): string {
  const item = parseCallMessage(bytes);
  if (!item) return '[通话记录]';
  return item.media === 'video' ? '视频通话' : '语音通话';
}
export function callMessageLabel(item: CallMessageSummary): string { return labels[item.outcome] || '通话记录'; }
export function isCallMessageType(msgType?: number): boolean { const types = getProto().IM.BaseDefine.MsgType; return msgType === types.MSG_TYPE_SINGLE_CALL || msgType === types.MSG_TYPE_GROUP_CALL; }
